var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiltersMatchedNothing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 129,
    viewBox: "0 0 95 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.02 124.16L67.02 126.91L52.49 101.86L46.74 91.94V104.73L32.7 96.62V67.72L2.5 15.64L7.42 12.74L57.61 99.3L72.02 124.16Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4898 54.56L66.5898 58.91L62.2298 62.78L52.6998 71.23L49.5498 74.02L21.5498 25.73L40.4898 36.66L60.3298 48.12L71.4898 54.56Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9097 116.72L87.0197 116.91L92.0197 114.16L86.9097 116.72Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4898 44.5599L69.5498 64.0199L64.4298 66.5799L52.6998 72.4499L49.5498 74.0199L52.6998 71.2299L62.2298 62.7799L66.5898 58.9099L71.4898 54.5599L91.4898 44.5599Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0199 114.16L86.9099 116.72L72.0199 124.16L57.6099 99.3L7.41992 12.74L27.4199 2.73999L36.4299 18.29L31.3199 20.85L21.5499 25.73L49.5499 74.02L52.6999 72.45L64.4299 66.58L92.0199 114.16Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4898 44.56L71.4898 54.56L60.3298 48.12L40.4898 36.66L21.5498 25.73L31.3198 20.85L36.4298 18.29L41.5498 15.73L91.4898 44.56Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.02 126.91L87.02 116.91",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4902 101.86L46.7402 104.73V91.9399L52.4902 101.86Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersMatchedNothing);
export default __webpack_public_path__ + "static/media/filters-matched-nothing.28fc22c9786a01064f57cea504ebc425.svg";
export { ForwardRef as ReactComponent };